import { render, staticRenderFns } from "./RecordTab.vue?vue&type=template&id=fd21f784&scoped=true&"
import script from "./RecordTab.vue?vue&type=script&lang=js&"
export * from "./RecordTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd21f784",
  null
  
)

export default component.exports